import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import AlertasVencimento from "@/components/AlertasVencimento";
import NotificationBell from "@/components/NotificationBell";
import {
  Building2,
  LayoutDashboard,
  ClipboardList,
  KanbanSquare,
  FileText,
  FolderOpen,
  DollarSign,
  Users,
  LogOut,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  Briefcase,
  UserCog,
  Building,
  FolderCog,
  Wallet,
  TrendingUp,
  FileBarChart,
  ArrowLeftRight,
  CircleDollarSign,
  Receipt,
  FileSignature,
  CreditCard,
  Package,
  Wrench,
  Target,
  BarChart3,
  Sun,
  Settings,
  Shield,
  Trash2,
  Calculator,
  HardHat,
  CalendarDays,
  Landmark,
  Scale,
  Truck,
  ClipboardCheck,
  BookOpen,
  FileSignature as FileSig,
  AlertOctagon
} from "lucide-react";

const LOGISTICA_MENU = {
  name: "Logística",
  icon: Truck,
  submenu: [
    { id: "log-romaneios", name: "Romaneios", href: "/logistica/romaneios", icon: Truck },
    { id: "log-nova-saida", name: "Nova saída para obra", href: "/logistica/nova-saida", icon: ClipboardList },
    { id: "log-conferencia", name: "Conferência", href: "/logistica/conferencia", icon: ClipboardCheck },
    { id: "log-caderno", name: "Caderno da Obra (FL-01)", href: "/logistica/caderno", icon: BookOpen },
    { id: "log-movimentacoes", name: "Movimentações", href: "/logistica/movimentacoes", icon: ArrowLeftRight },
    { id: "log-cautelas", name: "Cautelas", href: "/logistica/cautelas", icon: FileSig },
    { id: "log-ocorrencias", name: "Ocorrências", href: "/logistica/ocorrencias", icon: AlertOctagon },
    { id: "log-revisao", name: "Revisar lançamentos antigos", href: "/logistica/revisao-antigos", icon: ClipboardList },
  ]
};
import React, { useState } from "react";

const navigationItems = {
  admin: [
    { 
      name: "Operacional", 
      icon: HardHat,
      submenu: [
        { id: "op-os", name: "Ordens de Serviço", href: "/service-orders", icon: ClipboardList },
        { id: "op-cronogramas", name: "Cronogramas de Obra", href: "/operacional/cronogramas", icon: CalendarDays },
        { id: "op-cronogramas-dash", name: "Dashboard Executivo", href: "/operacional/cronogramas-dashboard", icon: LayoutDashboard },
      ]
    },
    { 
      name: "Comercial", 
      icon: Target,
      submenu: [
        { name: "Meu Dia", href: "/comercial/meu-dia", icon: Sun },
        { name: "CRM", href: "/comercial/crm", icon: KanbanSquare },
        { name: "Dashboard Comercial", href: "/comercial/dashboard", icon: BarChart3 },
        { name: "Propostas", href: "/comercial/propostas", icon: Receipt },
        { name: "Contratos", href: "/comercial/contratos", icon: FileSignature },
        { name: "Precificação Fachada", href: "/comercial/precificacao", icon: Calculator },
        { name: "Configurações", href: "/comercial/configuracoes", icon: Settings },
      ]
    },
    { 
      name: "Cadastros", 
      icon: FolderCog,
      submenu: [
        { id: "cf", name: "Clientes/Fornecedores", href: "/cadastros/clientes-fornecedores", icon: Building },
        { id: "func", name: "Funcionários", href: "/cadastros/funcionarios", icon: UserCog },
        { id: "cargos", name: "Cargos", href: "/cadastros/cargos", icon: Briefcase },
        { id: "users", name: "Usuários", href: "/cadastros/usuarios", icon: Users },
        { id: "estoque", name: "Estoque de Materiais", href: "/cadastros/estoque", icon: Package },
        { id: "ferramentas", name: "Ferramentas", href: "/cadastros/ferramentas", icon: Wrench },
        { id: "patrimonio", name: "Patrimônio (Equipamentos)", href: "/cadastros/patrimonio", icon: Wrench },
      ]
    },
    LOGISTICA_MENU,
    { 
      name: "Financeiro", 
      icon: DollarSign,
      submenu: [
        { id: "fin-geral", name: "Visão Geral", href: "/financeiro", icon: TrendingUp },
        { id: "fin-contas", name: "Contas a Pagar/Receber", href: "/financeiro/contas", icon: CreditCard },
        { id: "fin-cartoes", name: "Cartões de Crédito", href: "/financeiro/cartoes", icon: CreditCard },
        { id: "fin-categorias", name: "Categorias", href: "/financeiro/categorias", icon: CircleDollarSign },
        { id: "fin-bancos", name: "Bancos", href: "/financeiro/bancos", icon: Landmark },
        { id: "fin-conciliacao", name: "Conciliação", href: "/financeiro/conciliacao", icon: Scale },
        { id: "fin-cc", name: "Centro de Custo", href: "/financeiro/centro-custo", icon: CircleDollarSign },
        { id: "fin-pc", name: "Plano de Contas", href: "/financeiro/plano-contas", icon: FileText },
        { id: "fin-dre", name: "DRE Geral", href: "/financeiro/dre-geral", icon: FileBarChart },
        { id: "fin-drec", name: "DRE por Contrato", href: "/financeiro/dre-contrato", icon: FileBarChart },
        { id: "fin-fc", name: "Fluxo de Caixa", href: "/financeiro/fluxo-caixa", icon: ArrowLeftRight },
      ]
    },
    { name: "Segurança & Auditoria", href: "/admin/seguranca", icon: Shield },
    { name: "Limpeza Administrativa", href: "/admin/cleanup", icon: Trash2 },
  ],
  engineering: [
    { 
      name: "Operacional", 
      icon: HardHat,
      submenu: [
        { name: "Ordens de Serviço", href: "/service-orders", icon: ClipboardList },
        { name: "Cronogramas de Obra", href: "/operacional/cronogramas", icon: CalendarDays },
        { name: "Dashboard Executivo", href: "/operacional/cronogramas-dashboard", icon: LayoutDashboard },
      ]
    },
    { 
      name: "Comercial", 
      icon: Target,
      submenu: [
        { name: "Meu Dia", href: "/comercial/meu-dia", icon: Sun },
        { name: "CRM", href: "/comercial/crm", icon: KanbanSquare },
        { name: "Propostas", href: "/comercial/propostas", icon: Receipt },
        { name: "Contratos", href: "/comercial/contratos", icon: FileSignature },
      ]
    },
    { 
      name: "Cadastros", 
      icon: FolderCog,
      submenu: [
        { name: "Clientes/Fornecedores", href: "/cadastros/clientes-fornecedores", icon: Building },
        { name: "Estoque de Materiais", href: "/cadastros/estoque", icon: Package },
        { name: "Ferramentas", href: "/cadastros/ferramentas", icon: Wrench },
        { name: "Patrimônio (Equipamentos)", href: "/cadastros/patrimonio", icon: Wrench },
      ]
    },
    LOGISTICA_MENU,
    { 
      name: "Financeiro", 
      icon: DollarSign,
      submenu: [
        { name: "Visão Geral", href: "/financeiro", icon: TrendingUp },
        { name: "Cartões de Crédito", href: "/financeiro/cartoes", icon: CreditCard },
        { name: "DRE por Contrato", href: "/financeiro/dre-contrato", icon: FileBarChart },
      ]
    },
  ],
  operational: [
    { 
      name: "Operacional", 
      icon: HardHat,
      submenu: [
        { name: "Minhas Tarefas", href: "/service-orders", icon: ClipboardList },
        { name: "Cronogramas de Obra", href: "/operacional/cronogramas", icon: CalendarDays },
      ]
    },
    LOGISTICA_MENU,
  ],
  client: [
    { name: "Meus Projetos", href: "/client", icon: FolderOpen },
    { name: "Acompanhamento", href: "/projects", icon: FileText },
  ],
};

// Render a single submenu item - using native anchor with full page navigation
// This avoids React Router reconciliation issues that were corrupting text
const SubMenuItem = function SubMenuItem({ subItem, isActive, onNavigate }) {
  const IconComponent = subItem.icon;
  
  const handleClick = (e) => {
    e.preventDefault();
    onNavigate();
    // Use window.location for full page navigation to avoid React reconciliation issues
    window.location.href = subItem.href;
  };
  
  return (
    <a
      href={subItem.href}
      onClick={handleClick}
      data-menu-item={subItem.id || subItem.href}
      data-testid={`submenu-${subItem.id || subItem.href.replace(/\//g, '-')}`}
      className={cn(
        "flex items-center gap-3 px-4 py-2.5 rounded-neu-sm transition-all cursor-pointer relative",
        isActive
          ? "bg-[#06101D] text-white shadow-[inset_2px_2px_4px_rgba(0,0,0,0.45),inset_-2px_-2px_4px_rgba(255,255,255,0.04)]"
          : "text-white/60 hover:text-white hover:bg-white/5"
      )}
    >
      {isActive && (
        <span className="absolute left-0 top-2 bottom-2 w-[2px] rounded-r bg-luvcorp-gold shadow-[0_0_5px_rgba(201,168,76,0.5)]" />
      )}
      <IconComponent className={cn("h-4 w-4 flex-shrink-0", isActive && "text-luvcorp-gold")} />
      <span className="text-sm whitespace-nowrap select-none">
        {subItem.name}
      </span>
    </a>
  );
};

// NavItem component for main navigation items
const NavItem = function NavItem({ item, location, onNavigate, isOpen, onToggle }) {
  // Check if any submenu item is active
  const isSubmenuActive = item.submenu?.some(
    sub => location.pathname === sub.href || location.pathname.startsWith(sub.href + "/")
  );

  if (item.submenu) {
    const IconComponent = item.icon;
    return (
      <div className="w-full">
        <button
          type="button"
          onClick={onToggle}
          className={cn(
            "flex items-center justify-between w-full px-4 py-3 rounded-neu-sm transition-all relative",
            isSubmenuActive
              ? "bg-[#06101D] text-white shadow-[inset_2px_2px_5px_rgba(0,0,0,0.5),inset_-2px_-2px_5px_rgba(255,255,255,0.05)]"
              : "text-white/70 hover:text-white hover:bg-white/5 hover:shadow-[2px_2px_5px_rgba(0,0,0,0.3),-2px_-2px_5px_rgba(255,255,255,0.04)]"
          )}
        >
          {isSubmenuActive && (
            <span className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r bg-luvcorp-gold shadow-[0_0_6px_rgba(201,168,76,0.6)]" />
          )}
          <div className="flex items-center gap-3">
            <IconComponent className={cn("h-5 w-5 flex-shrink-0", isSubmenuActive && "text-luvcorp-gold")} />
            <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
          </div>
          {isOpen ? (
            <ChevronDown className="h-4 w-4 flex-shrink-0" />
          ) : (
            <ChevronRight className="h-4 w-4 flex-shrink-0" />
          )}
        </button>
        {isOpen && (
          <div className="pl-4 mt-1 space-y-1">
            {item.submenu.map((subItem) => {
              const isActive = location.pathname === subItem.href || 
                location.pathname.startsWith(subItem.href + "/");
              return (
                <SubMenuItem 
                  key={subItem.id || subItem.href}
                  subItem={subItem}
                  isActive={isActive}
                  onNavigate={onNavigate}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }

  const IconComponent = item.icon;
  const isActive = location.pathname === item.href || 
    (item.href !== "/" && location.pathname.startsWith(item.href));
  
  // Use native anchor with full page navigation for consistency
  const handleClick = (e) => {
    e.preventDefault();
    onNavigate();
    window.location.href = item.href;
  };
    
  return (
    <a
      href={item.href}
      onClick={handleClick}
      className={cn(
        "flex items-center gap-3 px-4 py-3 rounded-neu-sm transition-all cursor-pointer relative",
        isActive
          ? "bg-[#06101D] text-white shadow-[inset_2px_2px_5px_rgba(0,0,0,0.5),inset_-2px_-2px_5px_rgba(255,255,255,0.05)]"
          : "text-white/70 hover:text-white hover:bg-white/5 hover:shadow-[2px_2px_5px_rgba(0,0,0,0.3),-2px_-2px_5px_rgba(255,255,255,0.04)]"
      )}
      data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {isActive && (
        <span className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r bg-luvcorp-gold shadow-[0_0_6px_rgba(201,168,76,0.6)]" />
      )}
      <IconComponent className={cn("h-5 w-5 flex-shrink-0", isActive && "text-luvcorp-gold")} />
      <span className="text-sm font-medium whitespace-nowrap">{item.name}</span>
    </a>
  );
};

export default function MainLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Track which menus are open - persist across navigations
  const [openMenus, setOpenMenus] = useState(() => {
    // Initialize with menus that have active items
    const initial = {};
    const items = navigationItems[user?.role] || [];
    items.forEach((item, index) => {
      if (item.submenu) {
        const isActive = item.submenu.some(
          sub => location.pathname === sub.href || location.pathname.startsWith(sub.href + "/")
        );
        if (isActive) {
          initial[index] = true;
        }
      }
    });
    return initial;
  });

  const navItems = navigationItems[user?.role] || [];
  
  const toggleMenu = (index) => {
    setOpenMenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const getInitials = (name) => {
    return name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || "U";
  };

  const getRoleName = (role) => {
    const roles = {
      admin: "Administrador",
      engineering: "Engenharia",
      operational: "Operacional",
      client: "Cliente"
    };
    return roles[role] || role;
  };

  // Get current page name for header
  const getCurrentPageName = () => {
    for (const item of navItems) {
      if (item.href && (location.pathname === item.href || location.pathname.startsWith(item.href))) {
        return item.name;
      }
      if (item.submenu) {
        for (const sub of item.submenu) {
          if (location.pathname === sub.href || location.pathname.startsWith(sub.href + "/")) {
            return sub.name;
          }
        }
      }
    }
    if (location.pathname.startsWith("/logistica/conferencia-papel")) return "Conferência (lançar do papel)";
    if (location.pathname.startsWith("/logistica/nova-saida")) return "Nova saída para obra";
    return "Dashboard";
  };

  return (
    <div className="min-h-screen bg-neu-base" data-testid="main-layout">
      {/* Mobile Header */}
      <header className="lg:hidden fixed top-0 left-0 right-0 h-16 bg-neu-base shadow-neu-outset-sm z-50 flex items-center justify-between px-4 border-b border-white/40">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            data-testid="mobile-menu-btn"
          >
            {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
          <div className="flex items-center gap-2">
            <img src="/brand/obrasul-logo.jpeg" alt="OBRASUL-RJ" className="h-9 w-9 rounded-neu-sm object-cover shadow-neu-outset-sm" />
            <span className="font-heading font-bold text-luvcorp-navy">
              OBRA<span className="text-luvcorp-gold">SUL</span>-RJ
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <AlertasVencimento />
          <NotificationBell testIdSuffix="mobile" />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="rounded-full">
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-luvcorp-navy text-white text-xs">
                    {getInitials(user?.name)}
                  </AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <div className="px-2 py-1.5">
                <p className="text-sm font-medium">{user?.name}</p>
                <p className="text-xs text-slate-500">{getRoleName(user?.role)}</p>
              </div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleLogout} className="text-red-600">
                <LogOut className="mr-2 h-4 w-4" />
                Sair
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </header>

      {/* Sidebar */}
      <aside
        className={cn(
          "fixed top-0 left-0 bottom-0 w-64 bg-luvcorp-navy z-40 transform transition-transform duration-200 ease-in-out lg:translate-x-0",
          "shadow-[8px_0_24px_-4px_rgba(10,22,40,0.25)]",
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        )}
        data-testid="sidebar"
      >
        {/* Logo */}
        <div className="h-16 flex items-center justify-center border-b border-white/10 bg-gradient-to-b from-[#0F1F38] to-[#0A1628]">
          <div className="flex items-center gap-3">
            <img src="/brand/obrasul-logo.jpeg" alt="OBRASUL-RJ" className="h-10 w-10 rounded-neu-sm object-cover shadow-[2px_2px_6px_rgba(0,0,0,0.4),inset_0_1px_0_rgba(255,255,255,0.1)]" data-testid="sidebar-brand-logo" />
            <div>
              <h1 className="font-heading font-bold text-white text-lg leading-tight tracking-wide" data-testid="sidebar-brand-name">
                OBRA<span className="text-luvcorp-gold">SUL</span>-RJ
              </h1>
              <p className="text-[9px] text-white/60 tracking-wider leading-tight">Obra Padrão · Sistema de Gestão de Obras</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 4rem)' }}>
          <nav className="p-4 space-y-1 pb-8">
            {navItems.map((item, index) => (
              <NavItem 
                key={item.name} 
                item={item} 
                location={location}
                onNavigate={() => setSidebarOpen(false)}
                isOpen={openMenus[index] || false}
                onToggle={() => toggleMenu(index)}
              />
            ))}
          </nav>
        </div>

      </aside>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main className="lg:ml-64 min-h-screen pt-16 lg:pt-0">
        {/* Desktop Header */}
        <header className="hidden lg:flex h-16 bg-neu-base shadow-[0_2px_8px_rgba(10,22,40,0.06),inset_0_-1px_0_rgba(197,205,215,0.4)] items-center justify-between px-6 sticky top-0 z-20">
          <div>
            <h2 className="text-lg font-heading font-semibold text-luvcorp-navy tracking-tight">
              {getCurrentPageName()}
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <AlertasVencimento />
            <NotificationBell testIdSuffix="desktop" />
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="gap-2">
                  <Avatar className="h-8 w-8">
                    <AvatarFallback className="bg-luvcorp-navy text-white text-xs">
                      {getInitials(user?.name)}
                    </AvatarFallback>
                  </Avatar>
                  <span className="font-medium text-slate-700">{user?.name}</span>
                  <ChevronDown className="h-4 w-4 text-slate-400" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <div className="px-2 py-1.5">
                  <p className="text-sm font-medium">{user?.name}</p>
                  <p className="text-xs text-slate-500">{getRoleName(user?.role)}</p>
                </div>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout} className="text-red-600">
                  <LogOut className="mr-2 h-4 w-4" />
                  Sair
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </header>

        {/* Page Content */}
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
